module.exports = __webpack_public_path__ + "static/img/video.2addaeb2.png";